module.exports = __webpack_public_path__ + "media/63.39d271c1.wav";